/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
import React, { PureComponent } from 'react';
import { Segment } from 'semantic-ui-react';
import shortid from 'short-id';
import { sortAdsBy, getAdTypeOfAd } from '../../../utils/ad.common';
import ExpandAllComparer from './ExpandAllComparer';
import ComparerContainer from './CompareContainer';
import './ComparerTab.css';

class ComparerTab extends PureComponent {
  adTypes = [
    'Canvas',
    'Carousel',
    'Cinemagraph',
    'Collection',
    'Drone',
    'OEM',
    'Spot',
    'Still',
    'Video'
  ];

  renderDivider = (currentAd, nextAd, adTypes, campaignKey) => {
    try {
      const currentAdTypes = adTypes.filter((adType) =>
        currentAd.ad_name.toLowerCase().includes(adType.toLowerCase())
      );

      const currentAdType = getAdTypeOfAd(
        currentAd,
        currentAdTypes,
        campaignKey
      );

      const nextAdTypes = adTypes.filter((adType) =>
        nextAd.ad_name.toLowerCase().includes(adType.toLowerCase())
      );

      const nextAdType = getAdTypeOfAd(nextAd, nextAdTypes, campaignKey);

      const matchingAdTypes = currentAdType === nextAdType;

      return matchingAdTypes ? null : (
        <div>
          <Segment basic color="blue">
            <b>{nextAdType === '' ? 'Miscellaneous' : nextAdType} Ads</b>
          </Segment>
        </div>
      );
    } catch (error) {
      console.log('Error in renderDivider: ', error);
    }
  };

  renderAdTypeName = (ad) => {
    const foundAdType = this.adTypes.find((adType) =>
      ad.ad_name.includes(adType)
    );
    if (foundAdType) {
      return (
        <div>
          <Segment basic>
            <b>{foundAdType} Ads</b>
          </Segment>
        </div>
      );
    }
    return null;
  };

  render() {
    const {
      firstAds,
      sorting,
      secondAds,
      tabName,
      getFbToken,
      flipping,
      utms,
      adAccountName,
      diffFirstAds,
      diffSecondAds
    } = this.props;

    let adTypes = [];

    switch (tabName) {
      case 'VIDEO_VIEWS':
        adTypes = ['360', 'Drone', 'OEM', 'Spot', 'Video'];
        break;
      case 'LINK_CLICKS':
      case 'CONVERSIONS':
        adTypes = [
          'Canvas',
          'Carousel',
          'Cinemagraph',
          'Collection',
          'Still',
          'Video'
        ];
        break;
      case 'PRODUCT_CATALOG_SALES':
        adTypes = ['Carousel', 'Still'];
        break;
      default:
        adTypes = [''];
        break;
    }

    const allFirstAds = sortAdsBy(
      firstAds.concat(diffFirstAds),
      sorting,
      tabName,
      adTypes
    );
    const allSecondAds = sortAdsBy(
      secondAds.concat(diffSecondAds),
      sorting,
      tabName,
      adTypes
    );

    return (
      <div>
        <ExpandAllComparer />
        {allFirstAds.map((ad, index) => {
          const byNameFilter = allSecondAds.find(
            (item) => item.ad_name === ad.ad_name
          );
          const byLineage = allSecondAds.find(
            (item) =>
              item.lineageInfo &&
              ad.lineageInfo &&
              item.lineageInfo !== null &&
              ad.lineageInfo !== null &&
              item.lineageInfo.parentAdId === ad.lineageInfo.parentAdId
          );
          let secondAd;
          if (byNameFilter) {
            secondAd = byNameFilter;
          } else if (byLineage) {
            secondAd = byLineage;
          }

          return (
            <div>
              {sorting === 'type'
                ? index === 0
                  ? this.renderAdTypeName(ad)
                  : null
                : null}
              <ComparerContainer
                key={shortid.generate()}
                ad={ad}
                secondAd={secondAd}
                adAccordionIndex={index}
                tabName={tabName}
                getFbToken={getFbToken}
                flipping={flipping}
                utms={utms}
                adAccountName={adAccountName}
              />
              {sorting === 'type'
                ? index !== allFirstAds.length - 1
                  ? this.renderDivider(
                      allFirstAds[index],
                      allFirstAds[index + 1],
                      adTypes,
                      tabName
                    )
                  : null
                : null}
            </div>
          );
        })}
      </div>
    );
  }
}

export default ComparerTab;



// WEBPACK FOOTER //
// ./src/screens/Flipper/ParentSection/ComparerTab.js